import {
  GlobalService
} from './../../providers/global.config';
import {
  MileageComponent
} from './../mileage/mileage';
import {
  PathsList
} from './../paths-list/paths-list';
import {
  NavController,
  NavParams,
  AlertController,
  ModalController,
  LoadingController,
  ViewController,
  MenuController,
  ToastController
} from 'ionic-angular';
import {
  PointInterest
} from './../../objects/data-management';
import {
  Component
} from '@angular/core';
import {
  DataManagementService
} from '../../providers/data-management.service';
import {
  Poi
} from '../poi/poi';
import {
  ItemSliding
} from 'ionic-angular';

@Component({
  selector: 'page-gest-poi',
  templateUrl: 'gestpoi.html',
})
export class GestPoi {
  MARKER: any = "MARKER";
  POLYGON: any = "POLYGON";
  pointInterests: PointInterest[] = null;

 

  constructor(public navCtrl: NavController, public alertCtrl: AlertController, public toastCtrl: ToastController,
   private menu: MenuController, private dataManagementService: DataManagementService, public navParams: NavParams,
    public viewCtrl: ViewController, private modalCtrl: ModalController,private globalService : GlobalService) {

  }

  //
  openmenu() {
    this.menu.open();
  }
  //get all point d'interet
  ngOnInit() {
    this.loadPoi();
  }
  //
  loadPoi() {
    this.dataManagementService.getAllPointInterests().subscribe(pointInterests => {
      this.dataManagementService.pointInterests = pointInterests;
      this.pointInterests = pointInterests;
    });
  }

  delete(point: any) {
    let alert = this.alertCtrl.create({
      title: 'Attention',
      message: 'Voulez vous vraiment supprimer :' + point.name + '?',
      buttons: [{
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: 'Supprimer',
          handler: () => {
            this.deletepoi(point)
          }
        }
      ]
    });
    alert.present();
  }

// delete poi
  deletepoi(point: any) {
    this.dataManagementService.deletePointInterest(point.idPointInterest).subscribe((suprimed) => {
      if (suprimed) {
        if (point.type == "MARKER") {
          this.pointInterests.splice(this.pointInterests.indexOf(point), 1);
        }
        if (point.type == "POLYGON") {
          this.pointInterests.splice(this.pointInterests.indexOf(point), 1);
        }
        let toast = this.toastCtrl.create({
          message: '' + point.name + ' est supprimé avec succés',
          duration: 3000,
          position: 'top'
        });
        toast.present();
      } else {
      }
    }, () => {});
  }
  //edit poi open modal poi.ts
  edit(point: PointInterest) {

    let pointInterest = point;
    let PoiModal = this.modalCtrl.create(Poi, {
      pointInterest
    });
    PoiModal.present();
  }
  //end
}



// WEBPACK FOOTER //
// ./src/pages/gestpoi/gestpoi.ts